module.exports = __webpack_public_path__ + "img/dwn_arr_page.033beb91.svg";